/**
 * The admin console's switch control.
 *
 * Extracted from AiSummaryPage (which in turn mirrored FeatureFlagsPage) when
 * VisitNoteTypeCard became the third consumer. AiSummaryPage now imports this
 * instead of keeping its own copy.
 *
 * `role="switch"` + `aria-checked` is what the tests key off, and what makes the
 * control announce correctly — keep both if you restyle it.
 */
export function Toggle({
  enabled,
  onChange,
  disabled,
  label,
}: {
  enabled: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  /** Accessible name. Required wherever several toggles share a screen. */
  label?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!enabled)}
      className={
        "relative inline-flex w-10 h-6 rounded-full border-2 transition-colors duration-200 " +
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring " +
        (enabled ? "bg-primary border-primary" : "bg-muted border-border") +
        " disabled:opacity-40 disabled:cursor-not-allowed"
      }
    >
      <span
        className={
          "absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform duration-200 " +
          (enabled ? "translate-x-4" : "translate-x-0")
        }
      />
    </button>
  );
}

export default Toggle;
